import { combineReducers } from "redux";
import { selectProductReducer, setProductReducer } from "./product_reducer";

const reducer = combineReducers({
    allProducts:setProductReducer,
    product:selectProductReducer
})

export default reducer;